/* =========================================================================
   Entry: main.js
   - Bootstrap SCSS is imported above in ../scss/main.scss (Vite will bundle it)
   - Bootstrap JS (bundle) for dropdowns/modals/offcanvas
   - Swiper (sliders) with a safe looping mechanism
   - Lightbox replacement: Bootstrap Modal (no need for glightbox)
   - Toasts (Bootstrap Toast)
   - WooCommerce AJAX helpers + Load More functionality
   - axtonFav polyfill (in case the theme calls axtonFav.* anywhere)
   ========================================================================= */

// Styles (SCSS entry point)
import "../scss/main.scss";

// Bootstrap: make it globally available (for jQuery callbacks and WC events)
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// Swiper
import Swiper from "swiper";
import { Navigation, Autoplay, Thumbs, FreeMode, Mousewheel } from "swiper/modules";
import "swiper/css/bundle";

// Mini helpers for DOM querying
const $q = (sel, ctx = document) => ctx.querySelector(sel);
const $$q = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

/**
 * Enables loop only if there are enough slides.
 * @param {string|Element} rootSelector - The slider's root element or its selector.
 * @param {number} minSlides - The minimum number of slides required to enable loop.
 * @returns {boolean} - True if looping is enabled, otherwise false.
 */
function smartLoop(rootSelector, minSlides = 2) {
    const root = typeof rootSelector === "string" ? $q(rootSelector) : rootSelector;
    if (!root) return false;
    const count = root.querySelectorAll(".swiper-slide").length;
    return count >= minSlides;
}

/** Polyfill for a global object to prevent "axtonFav is not defined" errors */
window.axtonFav = window.axtonFav || {
    init() { /* no-op */ },
    toggle() { /* no-op */ },
};
document.addEventListener("DOMContentLoaded", () => window.axtonFav.init?.());


document.addEventListener("DOMContentLoaded", () => {
    // Helper functions, ak ich už máš, tieto ignoruj
    const $q = (selector) => document.querySelector(selector);
    const $$q = (selector) => document.querySelectorAll(selector);
    const smartLoop = (selector, minSlides) => ($$q(`${selector} .swiper-slide`).length >= minSlides);

    // ODSTRÁNENÁ OPRAVA v10 - bola príliš neskoro
    // const singleBtn = $q('form.cart .single_add_to_cart_button');
    // ...

    // Hero slider
    if ($q(".hero-slider")) {
        new Swiper(".hero-slider", {
            modules: [Navigation, Autoplay],
            loop: smartLoop(".hero-slider", 2),
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: { delay: 4000, disableOnInteraction: false },
            navigation: {
                nextEl: ".slider-nav-global .swiper-button-next",
                prevEl: ".slider-nav-global .swiper-button-prev",
            },
        });
    }

    // Products slider — loop is intentionally off (due to 2 slidesPerView on large breakpoints)
    if ($q(".productSwiper")) {
        new Swiper(".productSwiper", {
            modules: [Navigation, Autoplay], // ← toto musí byť aktívne
            loop: true,
            spaceBetween: 20,
            autoplay: { delay: 4000, disableOnInteraction: false },
            pagination: { el: ".swiper-pagination", clickable: true },
            breakpoints: {
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 1 },
                1200: { slidesPerView: 2 }
            }
        });
    }

    // Offers slider
    if ($q(".offers-swiper")) {
        new Swiper(".offers-swiper", {
            modules: [Navigation],
            loop: smartLoop(".offers-swiper", 2),
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        });
    }

    // Product gallery (thumbs → main) + Bootstrap Modal lightbox
    const thumbsRoot = $q(".swiper-thumbs");
    const mainRoot = $q(".swiper-main");

    if (thumbsRoot && mainRoot) {
        // Thumbnails slider
        const swiperThumbs = new Swiper(".swiper-thumbs", {
            modules: [FreeMode],
            slidesPerView: 5,
            spaceBetween: 10,
            freeMode: true,
            watchSlidesProgress: true,
        });

        // Main product image slider
        const swiperMain = new Swiper(".swiper-main", {
            modules: [Navigation, Autoplay, Thumbs],
            loop: smartLoop(".swiper-main", 2),
            spaceBetween: 10,
            navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
            autoplay: { delay: 2500, disableOnInteraction: true },
            thumbs: { swiper: swiperThumbs },
        });

        // Lightbox using Bootstrap Modal (no external library needed)
        let modalEl = $q("#imgLightbox");
        // If the modal doesn't exist in the DOM, create it dynamically
        if (!modalEl) {
            const wrap = document.createElement("div");
            wrap.innerHTML = `
        <div class="modal fade" id="imgLightbox" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content bg-transparent border-0">
              <button type="button" class="btn-close ms-auto me-2 mt-2" data-bs-dismiss="modal" aria-label="Close"></button>
              <div class="modal-body p-0 text-center">
                <img id="imgLightboxImg" src="" alt="Enlarged product image" class="img-fluid rounded-3">
              </div>
            </div>
          </div>
        </div>`;
            document.body.appendChild(wrap.firstElementChild);
            modalEl = $q("#imgLightbox");
        }
        const modalImg = $q("#imgLightboxImg");

        // Attach click events to open the lightbox
        if (window.bootstrap?.Modal) {
            const bsModal = new window.bootstrap.Modal(modalEl);
            $$q(".swiper-main .swiper-slide img").forEach((img) => {
                img.style.cursor = "zoom-in";
                img.addEventListener("click", () => {
                    const url = img.getAttribute("data-full") || img.getAttribute("src");
                    modalImg.src = url;
                    bsModal.show();
                });
            });
        }
    }

    /* ===========================
       RIEŠENIE PRE CATEGORY SLIDER
       =========================== */
    const catSliderEl = $q(".cat_item_slider");
    const scrollbarTrack = $q(".custom-scrollbar-track");
    const scrollbarThumb = $q(".custom-scrollbar-thumb");

    if (catSliderEl && scrollbarTrack && scrollbarThumb) {
        const catItemSlider = new Swiper(catSliderEl, {
            modules: [FreeMode, Mousewheel],
            slidesPerView: "auto",
            freeMode: true,
            spaceBetween: 20,
            slideToClickedSlide: true,
            mousewheel: { forceToAxis: true },

            // KROK 3: Pridaj `on` event handler
            on: {
                // Keď sa Swiper inicializuje, vykonaj túto funkciu
                init: function () {
                    // Nájdi najbližší rodičovský prvok s triedou .slider-is-loading
                    const wrapper = this.el.closest('.slider-is-loading');
                    if (wrapper) {
                        // Odstráň dočasnú triedu
                        wrapper.classList.remove('slider-is-loading');
                        // Pridaj triedu, ktorá slider plynule zobrazí
                        wrapper.classList.add('slider-is-loaded');
                    }
                },
            },
        });

        // Zvyšok tvojho kódu pre custom scrollbar ostáva nezmenený
        let isDragging = false;
        let startX = 0;
        let thumbStartX = 0;

        const updateScrollbar = () => {
            const virtual = catItemSlider.virtualSize || (catItemSlider.slidesSizesGrid ? catItemSlider.slidesSizesGrid.reduce((a, b) => a + b, 0) : catItemSlider.width);
            const ratio = Math.min(1, catItemSlider.width / (virtual || catItemSlider.width));
            const thumbWidthPct = Math.max(0.2, ratio) * 70;
            scrollbarThumb.style.width = `${thumbWidthPct}%`;
            const maxLeft = scrollbarTrack.offsetWidth - scrollbarThumb.offsetWidth;
            const pos = maxLeft > 0 ? catItemSlider.progress * maxLeft : 0;
            scrollbarThumb.style.transform = `translateX(${pos}px)`;
        };

        catItemSlider.on("progress", updateScrollbar);
        catItemSlider.on("resize", updateScrollbar);
        updateScrollbar();

        scrollbarThumb.addEventListener("mousedown", (e) => {
            isDragging = true;
            startX = e.clientX;
            thumbStartX = scrollbarThumb.offsetLeft;
            scrollbarThumb.style.transition = "none";
            e.preventDefault();
        });

        document.addEventListener("mousemove", (e) => {
            if (!isDragging) return;
            const deltaX = e.clientX - startX;
            const newLeft = thumbStartX + deltaX;
            const maxLeft = scrollbarTrack.offsetWidth - scrollbarThumb.offsetWidth;
            const clamped = Math.max(0, Math.min(newLeft, maxLeft));
            const progress = maxLeft ? clamped / maxLeft : 0;
            catItemSlider.setProgress(progress);
        });

        document.addEventListener("mouseup", () => {
            isDragging = false;
            scrollbarThumb.style.transition = "transform 0.2s ease";
        });

        scrollbarTrack.addEventListener("click", (e) => {
            if (e.target === scrollbarThumb) return;
            const clickX = e.clientX - scrollbarTrack.getBoundingClientRect().left;
            const trackW = scrollbarTrack.offsetWidth;
            const thumbW = scrollbarThumb.offsetWidth;
            const maxLeft = Math.max(1, trackW - thumbW);
            const progress = clickX / maxLeft;
            catItemSlider.setProgress(Math.max(0, Math.min(progress, 1)));
        });
    }
});
/* ===========================
   Toasts (Bootstrap 5)
   =========================== */
/**
 * Shows a Bootstrap 5 toast notification.
 * @param {string} message - The message to display.
 * @param {string} type - The type of toast (success, info, danger, warning).
 */
function showToast(message, type = "success") {
    if (!window.bootstrap?.Toast) return console.error("Bootstrap Toast is not available.");

    // Find or create the toast container
    let container = document.querySelector(".toast-container");
    if (!container) {
        const div = document.createElement("div");
        div.className = "toast-container position-fixed top-0 end-0 p-3";
        div.style.zIndex = "2000";
        document.body.appendChild(div);
        container = div;
    }

    const bgClassMap = {
        success: "bg-success text-white",
        info: "bg-primary text-white",
        danger: "bg-danger text-white",
        warning: "bg-warning",
    };
    const bgClass = bgClassMap[type] || "bg-secondary text-white";

    // Create the toast element
    const toastEl = document.createElement("div");
    toastEl.className = `toast align-items-center ${bgClass} border-0`;
    toastEl.setAttribute("role", "alert");
    toastEl.setAttribute("aria-live", "assertive");
    toastEl.setAttribute("aria-atomic", "true");

    toastEl.innerHTML = `
      <div class="d-flex">
        <div class="toast-body">${message}</div>
        <button type="button" class="btn-close ${bgClass.includes("text-white") ? "btn-close-white" : ""} me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
    `;

    container.appendChild(toastEl);
    const toast = new bootstrap.Toast(toastEl, { delay: 3000 });
    toast.show();

    // Clean up the DOM after the toast is hidden
    toastEl.addEventListener("hidden.bs.toast", () => toastEl.remove());
}

// Expose showToast globally for easy access
window.showToast = showToast;


/* ===========================
   WooCommerce AJAX helpers
   =========================== */
(function($) {
    if (!$) return;

    // === ODSTRÁNENÁ OPRAVA v12 ===

    // Helper to construct WooCommerce AJAX URLs
    function wcAjaxUrl(endpoint) {
        if (window.wc_add_to_cart_params && wc_add_to_cart_params.wc_ajax_url) {
            return wc_add_to_cart_params.wc_ajax_url.replace("%%endpoint%%", endpoint);
        }
        return "/?wc-ajax=" + endpoint;
    }

    // Helper to trigger a refresh of cart fragments (e.g., mini-cart)
    function refreshFragments() {
        $(document.body).trigger('wc_update_cart');
        $(document.body).trigger('update_checkout');
    }

    // ====================================================================
    //  ODSTRÁNENÝ: Handler "added_to_cart" (v9)
    // ====================================================================


    // ==========================
    //  REMOVE FROM CART (z main.js)
    // ==========================
    $(document).on("click", ".axton-remove-from-cart", function(e) {
        e.preventDefault();
        const $btn = $(this);
        const key = $btn.data("cart_item_key");
        if (!key) return;

        $btn.closest('.cart_item, .mini_cart_item, .xoo-wsc-product').css('opacity', 0.5);
        $btn.prop("disabled", true);

        $.ajax({
            url: wcAjaxUrl("remove_from_cart"),
            type: "POST",
            data: { cart_item_key: key },
            success: function(response) {
                // WooCommerce sa o refresh postará sám cez 'removed_from_cart' event
                if (!response || !response.fragments) {
                    refreshFragments();
                }
            },
            error: function() {
                window.showToast?.("Beim Entfernen des Produkts ist ein Fehler aufgetreten.", "warning");
                $btn.closest('.cart_item, .mini_cart_item, .xoo-wsc-product').css('opacity', 1);
                $btn.prop("disabled", false);
            },
        });
    });

    $(document.body).on('removed_from_cart', function(){
        window.showToast?.("Produkt wurde aus dem Warenkorb entfernt.", "info");
    });

})(jQuery);

/* ===========================
   Load More (Top Sellers)
   =========================== */
(function($) {
    if (!$) return;

    function ajaxUrl() {
        if (window.axton_ajax && window.axton_ajax.ajax_url) return window.axton_ajax.ajax_url;
        return "/wp-admin/admin-ajax.php";
    }

    $(document).on("click", ".axton-ts-loadmore", function(e) {
        e.preventDefault();
        const $btn = $(this);
        if ($btn.data("loading") === 1) return;

        const gridId = $btn.data("grid-id");
        const $grid = $("#" + gridId);

        const payload = {
            action: "axton_te_top_sellers_load",
            source: $btn.data("source") || "auto",
            page: parseInt($btn.data("page") || 1, 10),
            per_page: parseInt($btn.data("per-page") || 4, 10),
            ids: $btn.data("ids") || "",
            cats: $btn.data("cats") || "",
            only_stock: $btn.data("only-stock") || "0",
            orderby: $btn.data("orderby") || "total_sales",
            order: $btn.data("order") || "DESC",
        };

        // Použije 'security' kľúč z 'axton_ajax' objektu
        if (window.axton_ajax && window.axton_ajax.security) {
            payload.security = window.axton_ajax.security;
        }

        $btn.addClass("loading").data("loading", 1).prop("disabled", true);

        $.ajax({
            url: ajaxUrl(),
            type: "POST",
            dataType: "json",
            data: payload,
        })
            .done(function(res) {
                if (res && res.success && res.data) {
                    if ($grid.length && res.data.html) $grid.append(res.data.html);

                    if (res.data.has_more) {
                        $btn.data("page", payload.page + 1);
                        $btn.removeClass("loading").data("loading", 0).prop("disabled", false);
                    } else {
                        $btn.remove();
                    }
                } else {
                    $btn.remove();
                }
            })
            .fail(function() {
                $btn.removeClass("loading").data("loading", 0).prop("disabled", false);
            });
    });
})(jQuery);


/* ===========================
   AJAX Search
   =========================== */
(function($) {
    if (!$) return;
    $(document).ready(function() {
        const searchModal = $('#search-modal');
        const searchInput = $('#axton-ajax-search-input');
        const searchWrapper = $('.search-form-wrapper');
        const resultsContainer = $('#search-results-container');
        const openSearchBtn = $('.open-search-btn');
        const closeSearchBtn = $('#search-modal-close-btn');
        let searchTimeout;

        function openModal() {
            searchModal.fadeIn(200);
            setTimeout(() => searchInput.focus(), 50);
        }

        function closeModal() {
            searchModal.fadeOut(200);
        }

        openSearchBtn.on('click', function(e) {
            e.preventDefault();
            openModal();
        });

        closeSearchBtn.on('click', closeModal);
        searchModal.on('click', function(e) {
            if ($(e.target).is(searchModal)) {
                closeModal();
            }
        });
        $(document).on('keyup', function(e) {
            if (e.key === "Escape" && searchModal.is(':visible')) {
                closeModal();
            }
        });

        searchInput.on('keyup', function() {
            const searchTerm = $(this).val();
            clearTimeout(searchTimeout);

            if (searchTerm.length < 3) {
                resultsContainer.html('');
                searchWrapper.removeClass('is-loading');
                return;
            }

            searchWrapper.addClass('is-loading');

            searchTimeout = setTimeout(function() {
                $.ajax({
                    url: window.axton_ajax?.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'axton_ajax_search',
                        nonce: window.axton_ajax?.nonce, // Použije 'nonce' kľúč
                        term: searchTerm
                    },
                    success: function(response) {
                        if (response.success) {
                            resultsContainer.html(response.data.html);
                        } else {
                            resultsContainer.html('<div class="p-3 text-muted">' + (response.data?.message || 'No results found.') + '</div>');
                        }
                    },
                    error: function() {
                        resultsContainer.html('<div class="p-3 text-danger">Došlo k chybe. Skúste to prosím znova.</div>');
                    },
                    complete: function() {
                        searchWrapper.removeClass('is-loading');
                    }
                });
            }, 500);
        });

        $('body').on('click', '.suggestion-tag', function(e) {
            e.preventDefault();
            const term = $(this).data('term');
            searchInput.val(term).trigger('keyup').focus();
        });
    });
})(jQuery);


/* =========================================================================
   FIX: AJAX Cart Page Updates on Quantity Change
   ========================================================================= */
(function($) {
    if (!$) return;

    // This script should only run on the cart page.
    if (!$('body').hasClass('woocommerce-cart')) {
        return;
    }

    let cartUpdateTimeout;
    const updateDelay = 750; // 750ms delay to prevent spamming AJAX calls.

    function triggerCartUpdate() {
        // Find the "Update cart" button and trigger it. This is the
        // standard WooCommerce way to update the cart via AJAX.
        const updateButton = $('[name="update_cart"]');
        if (updateButton.length && !updateButton.prop('disabled')) {
            updateButton.trigger('click');
        }
    }

    // Listen for the 'change' event on any quantity input inside the cart form.
    // Your +/- buttons already trigger this event, so this will catch it.
    $(document).on('change', '.woocommerce-cart-form .qty', function() {
        // When the quantity changes, clear any previous timeout.
        clearTimeout(cartUpdateTimeout);

        // And set a new one. The cart will only update after the user has stopped
        // changing the quantity for the specified delay.
        cartUpdateTimeout = setTimeout(triggerCartUpdate, updateDelay);
    });

})(jQuery);


/**
 * Handles the responsive placement of the topbar element.
 *
 * This script moves the topbar between a desktop and mobile slot based on screen width.
 * It's wrapped in a DOMContentLoaded listener to ensure all elements are available before execution.
 */
document.addEventListener('DOMContentLoaded', () => {
    const mq = window.matchMedia('(max-width: 991.98px)');
    const topbar = document.getElementById('topbar');
    const mobileSlot = document.getElementById('topbar-mobile-slot');
    const desktopSlot = document.getElementById('topbar-desktop-slot');

    // Defensive check to ensure all required elements exist before proceeding.
    if (!topbar || !mobileSlot || !desktopSlot) {
        // console.warn('Topbar script could not find one or more required elements: #topbar, #topbar-mobile-slot, #topbar-desktop-slot');
        return;
    }

    /**
     * Moves the topbar to the correct slot based on the media query result.
     * This version is more concise by determining the target first.
     * @param {MediaQueryListEvent|MediaQueryList} e The media query event object or the list itself.
     */
    function placeTopbar(e) {
        // Determine the correct target slot based on whether the media query matches (mobile view).
        const targetSlot = e.matches ? mobileSlot : desktopSlot;

        // Only move the topbar if it's not already in the correct slot to avoid unnecessary DOM manipulation.
        if (topbar.parentNode !== targetSlot) {
            targetSlot.appendChild(topbar);
        }
    }

    // Set the initial position of the topbar on page load
    placeTopbar(mq);

    // Add a listener to move the topbar when the viewport size changes
    mq.addEventListener('change', placeTopbar);
});

// ======================================================
// ODSTRÁNENÝ: WooCommerce "Add to Cart" Fix
// ======================================================


jQuery(function($){
    const $input = $('#axton-ajax-search-input');
    const $results = $('#search-results-container');
    const $wrapper = $('.search-form-wrapper');
    let timer = null;


// debug: vyprintuj lokalizacny objekt (v konzole)
    console.log('axton_ajax:', window.axton_ajax);


    $input.on('keyup', function(){
        const term = $(this).val().trim();


        clearTimeout(timer);


        if (term.length < 3) {
            $results.html('');
            $wrapper.removeClass('is-loading');
            return;
        }


        $wrapper.addClass('is-loading');


        timer = setTimeout(function(){
            $.ajax({
                url: (window.axton_ajax && window.axton_ajax.ajax_url) ? window.axton_ajax.ajax_url : '/wp-admin/admin-ajax.php',
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'axton_ajax_search',
                    nonce: (window.axton_ajax && window.axton_ajax.nonce) ? window.axton_ajax.nonce : '',
                    term: term
                },
                success: function(res){
                    if (res && res.success && res.data && res.data.html) {
                        $results.html(res.data.html);
                    } else {
                        const msg = (res && res.data && res.data.message) ? res.data.message : 'Nič sa nenašlo';
                        $results.html('<div class="p-3 text-muted">' + msg + '</div>');
                    }
                },
                error: function(xhr, status, err){
                    console.error('AJAX search error:', status, err, xhr.responseText);
                    $results.html('<div class="p-3 text-danger">Došlo k chybe. Skontroluj konzolu.</div>');
                },
                complete: function(){
                    $wrapper.removeClass('is-loading');
                }
            });
        }, 450);
    });


// optional: click on suggestion tag
    $('body').on('click', '.suggestion-tag', function(e){
        e.preventDefault();
        const t = $(this).data('term') || $(this).text();
        $input.val(t).trigger('keyup').focus();
    });
});


// --- AJAX SEARCH (modal) ---
jQuery(function ($) {
    const $input   = $('#modalsearch input[type="search"]');
    const $results = $('#search-results');
    let timer = null;

    if (!$input.length || !$results.length) return;

    $input.on('input', function () {
        const term = $(this).val().trim();
        clearTimeout(timer);

        if (term.length < 3) { $results.empty(); return; }

        timer = setTimeout(function () {
            $results.empty();

            $.ajax({
                url: (window.axton_ajax && axton_ajax.ajax_url) || '/wp-admin/admin-ajax.php',
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'axton_ajax_search',
                    term: term,
                    // security je OK, ale na serveri už NEbudeme padať, ak chýba/nesedí
                    security: (window.axton_ajax && axton_ajax.security) || ''
                }
            })
                .done(function (res) {
                    if (res && res.success && res.data && res.data.html) {
                        $results.html(res.data.html);
                    } else {
                        $results.html('<p class="text-muted">Keine Ergebnisse.</p>');
                    }
                })
                .fail(function () {
                    $results.html('<p class="text-danger">Fehler bei der Suche.</p>');
                });
        }, 300);
    });
});
